"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import DateFormat from "@/framework/timeformatter";
let ItemElementExpireDate = class extends Vue {
  get check_date() {
    return DateFormat.format_expire_time(DateFormat.check(this._item.end_time));
  }
  get check_detail_date() {
    return DateFormat.format_expire_detail_time(DateFormat.check(this._item.end_time));
  }
};
__decorateClass([
  PropSync("item")
], ItemElementExpireDate.prototype, "_item", 2);
ItemElementExpireDate = __decorateClass([
  Component({})
], ItemElementExpireDate);
export {
  ItemElementExpireDate as default
};
